import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactForm } from "./utils";
import { useMutations } from "./utils/react-hook/use-mutations";
import { Label } from "@/components/ui/label";

export const Profile = () => {
  const { profileData, onFormSubmit } = useMutations();

  return (
    <Card>
      <CardHeader className="flex justify-between items-center flex-row">
        <CardTitle>Profile</CardTitle>
        <Label>
          Hi, <strong className="capitalize">{profileData?.username}</strong>
        </Label>
      </CardHeader>
      <hr />
      <ReactForm onFormSubmit={onFormSubmit} formData={profileData} />
    </Card>
  );
};
